import { philosophyItems } from '@/mocks/home';

export default function PhilosophySection() {
  return (
    <section className="py-20 md:py-28 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-16">
          <p className="text-primary-500 font-heading text-sm tracking-[0.2em] mb-3">风月之道</p>
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900">
            以风为骨，以月为魂
          </h2>
          <p className="mt-4 text-foreground-500 max-w-2xl mx-auto leading-relaxed text-sm">
            风月不仅是一个意象，更是一种生活态度。在爱风月，我们相信每个人都可以在日常生活中寻得属于自己的诗意栖居。
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {philosophyItems.map((item, index) => (
            <div
              key={index}
              className="group bg-background-50 border border-background-200/70 rounded-lg p-8 md:p-10 hover:border-primary-200/50 transition-all duration-500"
            >
              <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center rounded-full bg-primary-50 text-primary-500 mb-6 group-hover:bg-primary-500 group-hover:text-white transition-all duration-500">
                <i className={`${item.icon} text-2xl`} />
              </div>
              <h3 className="font-heading text-xl font-semibold text-foreground-900 mb-3">
                {item.title}
              </h3>
              <p className="text-foreground-500 text-sm leading-relaxed">
                {item.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}